import { create } from 'zustand';
import { IGroupedMention } from '../types/dashboard.types';

interface IMentionsState {
  pendingViewingMentions: IGroupedMention[];
  pendingResolutionMentions: IGroupedMention[];
  resolvedMentions: IGroupedMention[];
  isLoading: boolean;
  isColumnsLoading: boolean;
  setPendingViewingMentions: (mentions: IGroupedMention[]) => void;
  setPendingResolutionMentions: (mentions: IGroupedMention[]) => void;
  setResolvedMentions: (mentions: IGroupedMention[]) => void;
  setIsLoading: (loading: boolean) => void;
  setIsColumnsLoading: (loading: boolean) => void;
  updateAllMentions: (mentions: {
    pendingViewingMentions: IGroupedMention[];
    pendingResolutionMentions: IGroupedMention[];
    resolvedMentions: IGroupedMention[];
  }) => void;
}

/**
 * Estado global para manejar las menciones del dashboard
 */
const useMentionsState = create<IMentionsState>(set => ({
  pendingViewingMentions: [],
  pendingResolutionMentions: [],
  resolvedMentions: [],
  isLoading: false,
  isColumnsLoading: false,
  setPendingViewingMentions: pendingViewingMentions => set({ pendingViewingMentions }),
  setPendingResolutionMentions: pendingResolutionMentions => set({ pendingResolutionMentions }),
  setResolvedMentions: resolvedMentions => set({ resolvedMentions }),
  setIsLoading: isLoading => set({ isLoading }),
  setIsColumnsLoading: isColumnsLoading => set({ isColumnsLoading }),
  updateAllMentions: mentions =>
    set({
      pendingViewingMentions: mentions.pendingViewingMentions,
      pendingResolutionMentions: mentions.pendingResolutionMentions,
      resolvedMentions: mentions.resolvedMentions
    })
}));

export default useMentionsState;
